import React from 'react';
import { motion } from 'framer-motion';
import { Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { shopInfo } from '../data/menuData';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#0F0E0D] py-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="flex items-center gap-2"
          >
            <span className="font-playfair text-2xl font-bold text-[#9F3E1F]">
              AK-AL
            </span>
            <span className="font-manrope text-[#FDFBF7]/60">
              {shopInfo.fullName}
            </span>
          </motion.div>

          {/* Copyright */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="flex items-center gap-2 text-[#FDFBF7]/60 font-manrope text-sm"
          >
            <span>© {new Date().getFullYear()} {shopInfo.name}.</span>
            <span>{t('footer.rights')}</span>
          </motion.div>

          {/* Made with love */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="flex items-center gap-2 text-[#FDFBF7]/60 font-manrope text-sm"
          >
            <span>{t('footer.madeWith')}</span>
            <Heart size={16} className="text-[#9F3E1F] fill-[#9F3E1F]" />
            <span>{t('footer.in')}</span>
          </motion.div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
